module.exports = __webpack_public_path__ + "static/media/koniagLogo.e3944bad.png";


//////////////////
// WEBPACK FOOTER
// ./src/logos/koniagLogo.png
// module id = 997
// module chunks = 0